import Phaser from 'phaser'
var start_button 
export default class YouWinscene extends
Phaser.Scene 
{ 
    constructor () 
    {  
        super('start-scene')
    }

    init (data) 
    {
        this.gameHalfWidth = this.scale.width * 0.5 
        this.gameHalfHeight = this.scale.height * 0.5 
        this.startGame = false 
    }
    
    preload() 
    {
        this.load.image('background', 'images/sky.png')
        this.load.image ('start', 'images/start.png')
        this.load.image ('cloud', 'images/cloud.png')
        this.load.image ('reo', 'images/reo.png')
        this.load.audio ('start', 'sfx/start.wav')
    
    }

    create() 
    { 
      

        this.add.image (this.gameHalfWidth, this.gameHalfHeight, 'background').setScale(2)
        this.clouds = this.physics.add.staticGroup ( { 
            key : 'cloud',
            repeat: 50
        })
        Phaser.Actions.RandomRectangle (this.clouds.getChildren(), this.physics.world.bounds); 
        this.add.image (this.gameHalfWidth, this.gameHalfHeight-100, 'reo')       
        let start_button = this.add.image (this.gameHalfWidth, this.gameHalfHeight+250, 'start').setInteractive().setScale(0.5)
        start_button.on ('pointerdown', () => { 
            this.sound.play ('start')
            this.gameStart()
        })
       
    }

    gameStart() 
    { 
        this.startGame= true
        this.scene.start('reo-mathematics-scene', { score: null,
            totalEnemy: null})
    }


}
